var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntSpin',{attrs:{"spinning":_vm.loading,"delay":_vm.delay}},[_vm._t("default"),_c('Icon',{attrs:{"slot":"indicator","name":"loading"},slot:"indicator"}),_c('div',{staticClass:"spin-content"},[_vm._t("message")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }